import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({ standalone:false,
  selector: 'app-mat-spinner-overlay',
  templateUrl: './mat-spinner-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mat-spinner-overlay.component.scss']
})
export class MatSpinnerOverlayComponent {

  readonly value = input<number>(100);
  readonly diameter = input<number>(100);
  readonly mode = input<ProgressSpinnerMode>("indeterminate");
  readonly strokeWidth = input<number>(10);
  readonly overlay = input<boolean>(false);
  readonly color = input<ThemePalette>("primary");

}